import React from 'react';
import Grid from '@mui/material/Grid2';
import {
    Box,
    FormControlLabel,    
    Checkbox,
    Autocomplete, 
    Chip,
    TextField,
    Button,
    Typography,
    FormGroup,
    FormControl,
    FormHelperText,
    Select,
    MenuItem,
    Tooltip, 
    IconButton,
} from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';

import { Formik } from 'formik';
import * as Yup from "yup";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import moment from 'moment';
import PageLoader from '../../components/pageloader/pageLoader';
import { useNavigate } from "react-router-dom";

import { useStoreActions } from 'easy-peasy';

const validationSchema = Yup.object({
    /*service_date: Yup.date()
      .min(new Date(), "Date cannot be in the past")
      .required("Service date is required"),
    */
});


const SearchForm = ({setFormSubmitted, orgId, urlParams, setSearchResult, showLOB, setShowLOB}) => {

    const formikRef = React.useRef(null);


    const [openLoader, setOpenLoader] = React.useState(false);
    const [lobOptions] = React.useState(urlParams?.lob ? urlParams?.lob?.split(",") : []);

    const navigate = useNavigate(); // Hook for navigation   

    const [selectedLobs, setSelectedLobs] = React.useState(lobOptions);
    const [programPolicies, setProgramPolicies] = React.useState([]);

    const policyAction = useStoreActions((actions) => actions.policy);

    const serviceDateFromUrl = dayjs(urlParams?.service_date, "YYYY-MM-DD", true);
    //const today = dayjs();

    const allowedStatuses = ["Published", "Review"];


    const [initialValues] = React.useState({
        keywords: urlParams?.keyword,
        procedure_code: urlParams?.procedure_code,
        lob: urlParams?.lob ? urlParams?.lob?.split(",") : [],
        policy_shortname: urlParams?.policy_shortname ? urlParams?.policy_shortname : null,
        //service_date: serviceDateFromUrl.isValid() && !serviceDateFromUrl.isBefore(today, 'day') ? serviceDateFromUrl : today,
        service_date: serviceDateFromUrl.isValid() ? serviceDateFromUrl : null,
        status: urlParams?.status ? Array.isArray(urlParams.status) ? urlParams.status.filter(s => allowedStatuses.includes(s)) : allowedStatuses.includes(urlParams.status) ? [urlParams.status] : ["Published"] : ["Published"],
    });

    function onFormSubmit(values, {resetForm}) {

        setFormSubmitted(true)

        setOpenLoader(true);

        let reqParams = {
            orgId: orgId,
            //lob: values?.lob, 
            lob: selectedLobs,
            procedure_code: values?.procedure_code, 
            service_date: values?.service_date ? moment(values?.service_date?.toDate?.()).format("YYYY-MM-DD") : null, 
            keyword: values?.keywords, 
           // policy_type: values?.policy_type, 
            status: values?.status,
            //policy_shortname: (values?.policy_shortname && values?.policy_shortname!==-1) ? values?.policy_shortname : ""
            policy_shortname: values?.policy_shortname ? values?.policy_shortname : ''
        }


        const formattedDate = moment(values?.service_date?.toDate?.()).format("YYYY-MM-DD");

        // Move the URL update HERE:
        const query = new URLSearchParams({
            lob: selectedLobs || "",
            procedure_code: values?.procedure_code || "",
            service_date: formattedDate,
            keyword: values?.keywords || "",
            status: values?.status || "",
            policy_shortname: values?.policy_shortname || ""
        }).toString();

        navigate(`?${query}`, { replace: true });

        policyAction.searchPolicies(reqParams).then(function(response) {

            setSearchResult(response?.data?.data?.results)

            if (response?.data?.data?.programPolicies) {
                setProgramPolicies(response?.data?.data?.programPolicies);
            }

            setOpenLoader(false);

        })
        .catch(function (error) {

            setSearchResult([]);

            setOpenLoader(false);
          
        });

    }


    React.useEffect(() => {
        setSelectedLobs(lobOptions);

        if (lobOptions && lobOptions?.length>1) {
            setShowLOB(true)
        }
        else {
            setShowLOB(false)
        }
        
    }, [lobOptions, setShowLOB]);


    React.useEffect(() => {
        //console.log('lobOptions--', lobOptions)
       // setIntialValues({...initialValues, lob: lobOptions[0]})
    }, [lobOptions, initialValues]);

    React.useEffect(() => {
        //setIntialValues({...initialValues, lob: selectedLobs})
    }, [selectedLobs, initialValues]);

    React.useEffect(() => {
        if (formikRef.current) {
            formikRef.current.submitForm();
        }
    }, []);
    
    
    return (<LocalizationProvider dateAdapter={AdapterDayjs}>
            <Box component="section" className="headerBox" style={{marginTop:'10px'}}>
                <Formik
                    initialValues={initialValues}
                    innerRef={formikRef} // Attach Formik instance to ref
                    onSubmit={onFormSubmit}
                    validationSchema={validationSchema}
                    enableReinitialize={true}
                >
                    {(formikProps) => {
                    const {
                        values,
                        touched,
                        errors,
                        handleChange,
                        setFieldValue,
                        handleBlur,
                        handleSubmit,
                        isValid,
                        setFieldTouched,
                    } = formikProps;

                        const today = dayjs();
                        const maxDate = today.add(45, "day");

                        const isFinalChecked = values.status.includes("Published");
                        const isDraftChecked = values.status.includes("Review");

                        const minDate = isDraftChecked && !isFinalChecked ? today : undefined; // undefined means no restriction



                        return (
                            <form onSubmit={handleSubmit} noValidate>
                                {/** Main container */}
                                <Grid container className="container" spacing={2}>
                                    <Grid item size={{ xs: 12, sm: 7, md: 7 }}>
                                        <Typography variant="h6" component="h6" className="filterFormLabel" style={{fontSize: '14px', fontWeight: 'bold'}}><label>Keyword</label></Typography>
                                        <TextField 
                                            label=""
                                            placeholder="Enter keywords..." 
                                            name="keywords"
                                            variant="outlined" 
                                            fullWidth 
                                            value={values?.keywords}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            error={touched?.keywords && Boolean(errors?.keywords)}
                                            helperText={touched?.keywords && errors?.keywords}
                                        />
                                    </Grid>

                                    <Grid item size={{ xs: 12, sm: 5, md: 5 }}>
                                        <Typography variant="h6" component="h6" className="filterFormLabel" style={{fontSize: '14px', fontWeight: 'bold'}}><label>Programs</label></Typography>
                                        <FormControl variant="outlined"
                                            fullWidth
                                            className={``}>
                                            <Select
                                                fullWidth
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                placeholder="Select a Program..."
                                                label=""
                                                defaultValue={(values?.policy_shortname ) ? values?.policy_shortname : "" }
                                                name="policy_shortname"
                                                variant="outlined" 
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={touched?.policy_shortname && Boolean(errors?.policy_shortname)}
                                                helperText={touched?.policy_shortname && errors?.policy_shortname}
                                                displayEmpty
                                            >
                                                <MenuItem value="">Select</MenuItem>
                                                {programPolicies.length>0 ? programPolicies.map( item => <MenuItem value={item.shortname}>{item.title}</MenuItem>)  : null}
                                            </Select>
                                        </FormControl>

                                        
                                        
                                    </Grid>

                                    <Grid item size={{ xs: 12, sm: 4, md: 4 }}>
                                        <Typography variant="h6" component="h6" className="filterFormLabel" style={{fontSize: '14px', fontWeight: 'bold'}}><label>Procedure Code</label></Typography>
                                        <TextField 
                                            label=""
                                            placeholder="Enter procedure code..." 
                                            name="procedure_code"
                                            variant="outlined" 
                                            fullWidth 
                                            value={values?.procedure_code}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            error={touched?.procedure_code && Boolean(errors?.procedure_code)}
                                            helperText={touched?.procedure_code && errors?.procedure_code}
                                        />
                                    </Grid>

                                    <Grid item  size={{ xs: 12, sm: 3, md: 3 }}>
                                        <Typography variant="h6" component="h6" className="filterFormLabel" style={{fontSize: '14px', fontWeight: 'bold'}}><label>Policy Status</label></Typography>
                                        <FormGroup 
                                        row
                                        name="status"
                                        style={{display: 'flex', alignItems: 'center'}}
                                        >
                                            <FormControlLabel control={<Checkbox onChange={handleChange} value="Published" name="status" checked={values.status.includes("Published")} />} label="Final" />
                                            <FormControlLabel control={<Checkbox onChange={handleChange} value="Review" name="status" checked={values.status.includes("Review")} />} label="Draft" />
                                        </FormGroup>

                                    </Grid>

                                    {showLOB && (<Grid item  size={{ xs: 12, sm: 5, md: 5 }}>
                                        <Typography variant="h6" component="h6" className="filterFormLabel" style={{fontSize: '14px', fontWeight: 'bold'}}><label>Line of Business</label></Typography>

                                        <FormControl
                                            variant="outlined"
                                            fullWidth
                                            className={``}
                                        >
                                            <Autocomplete
                                                name="lob"
                                                multiple
                                                options={lobOptions.filter((option) => !selectedLobs.includes(option))}
                                                getOptionLabel={(option) => option}
                                                value={selectedLobs}
                                                label="Select LOB"
                                                onChange={(event, newValue) => setSelectedLobs(newValue)}
                                                renderTags={(tagValue, getTagProps) =>
                                                    tagValue.map((option, index) => (
                                                    <Chip {...getTagProps({ index })} key={option} label={option} />
                                                    ))
                                                }
                                                renderInput={(params) => <TextField placeholder="Select a LOB..." {...params} label="" variant="outlined" />}
                                            />
                                            <FormHelperText
                                            className={
                                                errors.lob &&
                                                touched.lob &&
                                                errors.lob
                                                ? 'Mui-error'
                                                : ''
                                            }
                                            >
                                            {errors.lob &&
                                                touched.lob &&
                                                errors.lob}
                                            </FormHelperText>
                                        </FormControl>
                                    </Grid>)}

                                    <Grid item size={{ xs: 12, sm: 5, md: 5 }} style={{position:'relative'}}>
                                        <Typography variant="h6" component="h6" className="filterFormLabel" style={{fontSize: '14px', fontWeight: 'bold'}}><label>Policy Date</label></Typography>
                                        
                                        <DesktopDatePicker
                                            label=""
                                            inputFormat="MM/DD/YYYY"
                                            value={dayjs(values?.service_date).isValid() ? dayjs(values?.service_date) : null}
                                            minDate={minDate}
                                            maxDate={maxDate}
                                            onChange={(value) => {
                                                setFieldValue("service_date", value, true);
                                                setFieldTouched("service_date", true);
                                            }}
                                            slotProps={{
                                                textField: {
                                                fullWidth: true,
                                                name: 'service_date',
                                                error: Boolean(touched?.service_date && errors?.service_date),
                                                helperText: touched?.service_date && errors?.service_date,
                                                },
                                            }}

                                        />
                                        {values?.service_date && (<Tooltip title="Remove Date">
                                            <IconButton
                                            className={`closeEndDatePosition`}
                                            color="primary"
                                            aria-label="Remove Date"
                                            onClick={() => { 
                                                setFieldValue("service_date", null, true);
                                                setFieldTouched("service_date", true);
                                            }}
                                            >
                                                <ClearIcon />
                                            </IconButton>
                                        </Tooltip>)}

                                    </Grid>

                                    <Grid item size={12} style={{textAlign: 'right'}}>
                                        <Button color="primary" variant="contained" disabled={!isValid}  onClick={(e) => {
                                            /*
                                            let params = {
                                                lob: values?.lob ? values?.lob : "", 
                                                procedure_code: values?.procedure_code ? values?.procedure_code : "", 
                                                service_date: moment(values?.service_date).format("YYYY-MM-DD"), 
                                                keyword: values?.keywords ? values?.keywords : "", 
                                                status: values?.status ? values?.status : "",
                                                policy_shortname: (values?.policy_shortname && values?.policy_shortname!==-1) ? values?.policy_shortname : ""
                                            }

                                            const query = new URLSearchParams(params).toString();
                                            navigate(`?${query}`, { replace: true }); // Update URL with GET parameters

                                            */

                                            formikRef.current.submitForm();

                                        }}  >
                                            Submit
                                        </Button>
                                    </Grid>

                                </Grid>
                            </form>);
                    }}
                </Formik>

                 {/* Loader Overlay */}
                <PageLoader openLoader={openLoader} isGlobal={true} />

            </Box>
        </LocalizationProvider>)
}

export default SearchForm;